import script from "./WorkflowDetailsMitreSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowDetailsMitreSection.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowDetailsMitreSection.vue?vue&type=style&index=0&id=b72e03be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b72e03be"]])

export default __exports__